import _ from 'lodash';

export default class EstimateAllocateUtils {

    static hoursToMinutes(hours:number) {
        const value = hours ? hours : 0;
        return Math.round(value * 60);
    }

    static minutesToHours(minutes:number, decimals = 2) {
        const value = minutes ? minutes : 0;
        return gd.utils.roundToDecimals(value / 60, decimals);
    }

    static normalizeHours(hours:number) {
        return EstimateAllocateUtils.minutesToHours(EstimateAllocateUtils.hoursToMinutes(hours));
    }

    static normalizeStringInputToMinutes(inputString:string, workday = 8) {
        const {days,hours,minutes} = EstimateAllocateUtils.convertStringInputToDaysHoursMinutes(inputString);
        return EstimateAllocateUtils.convertDaysHoursMinutesToMinutes(days, hours, minutes, workday);
    }

    static convertStringInputToDaysHoursMinutes(inputString:string) {
        const regExp = /((((\d+(\.\d+)?)\s*(days|day|d)+)*)(((\d+(\.\d+)?)\s*(minutes|mins|min|m)+)*))(((\d+(\.\d+)?)\s*(hours|hour|h)*)*)/gmi;

        let days:string|number = 0, minutes:string|number = 0, hours:string|number = 0;
        let matchArr = inputString ? [...inputString.matchAll(regExp)] : [];
        _.map(matchArr, m=>{
            if (!days && m[4]) days = m[4];
            if (!minutes && m[9]) minutes = m[9];
            if (!hours && m[14]) hours = m[14];
        });

        return {days,hours,minutes};
    }

    static convertDaysHoursMinutesToMinutes(days:string|number, hours:string|number, minutes:string|number, workday:string|number = 8) {
        let res = 0;
        const floatDays = typeof days === 'number' ? days : parseFloat(days);
        const floatHours = typeof hours === 'number' ? hours : parseFloat(hours);
        const floatMinutes = typeof minutes === 'number' ? minutes : parseFloat(minutes);
        const floatWorkday = typeof workday === 'number' ? workday : parseFloat(workday);

        res += floatDays * floatWorkday * 60;
        res += floatHours * 60;
        res += floatMinutes;
        return res;
    }

    static convertMinutesToDaysHoursMinutes(minutesValue:number, workday = 8) {
        const minutes = minutesValue % 60;
        const hours = Math.floor(minutesValue/60) % workday;
        const days = Math.floor(minutesValue/60/workday);
        return {days,hours,minutes};
    }
}